// App.js
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import { ApolloClientProvider } from './components/utils/ApolloProvider';
import { SocketProvider } from './components/utils/SocketProvider';
import { PopupProvider } from './components/utils/PopupProvider';
import router from './Router';
import './App.css';
import "react-toastify/dist/ReactToastify.css";

export default function App() {
    return (
        <ApolloClientProvider>
            <SocketProvider>
                <PopupProvider>
                    <RouterProvider router={router} />
                    <ToastContainer style={{ zIndex: 99999 }} />
                </PopupProvider>
            </SocketProvider>
        </ApolloClientProvider>
    );
}